module.exports = __webpack_public_path__ + "static/media/contact.c52465ef.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/contact.jpg
// module id = 5768
// module chunks = 0